<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="full-page" :class="pageClass">
        <div class="content">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>
        <footer class="footer">
          <div class="container-fluid">
            <ul class="nav auth-footer-nav">
              <li class="nav-item">
                <a
                  :href="url"
                  target="_blank"
                  rel="noopener"
                  class="nav-link"
                >
                  {{ storeName }}
                </a>
              </li>
              <li
                class="nav-item"
                v-for="(link, index) in orderedFooterLinks"
                :key="'auth-footer-link-' + index"
              >
                <a
                  :href="link.url"
                  target="_blank"
                  rel="noopener"
                  class="nav-link"
                >
                  {{ link.name }}
                </a>
              </li>
            </ul>
            <div class="copyright">
              <span style="padding: 0px 10px">
                {{ footerBranding.label }} &nbsp; <i class="tim-icons icon-heart-2"></i> &amp;
                <a v-if="footerBranding.productUrl" :href="footerBranding.productUrl" target="_blank" rel="noopener">{{ footerBranding.productName }}</a>
                <span v-else>{{ footerBranding.productName }}</span>
                &bull;
                <a v-if="footerBranding.authorUrl" :href="footerBranding.authorUrl" target="_blank" rel="noopener">{{ footerBranding.authorName }}</a>
                <span v-else>{{ footerBranding.authorName }}</span>
                &copy; {{ year }}.
              </span>
            </div>
            <div class="copyright">
              <base-input>
                <el-select
                  v-model="myLang"
                  class="select-primary"
                  @change="changeLang"
                  style="display: inline-block !important"
                  popper-class="language-select-grid"
                >
                  <el-option
                    v-for="option in langs"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </base-input>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { ZoomCenterTransition } from 'vue2-transitions';
import { Select, Option } from 'element-ui';

export default {
  components: {
    ZoomCenterTransition,
    [Option.name]: Option,
    [Select.name]: Select
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    }
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: 'login-page',
      langs: [
        {id: 'en', name: 'English'},
        {id: 'nl', name: 'Nederlands'},
        {id: 'fr', name: 'Français'},
        {id: 'es', name: 'Español'},
        {id: 'de', name: 'Deutsch'},
        {id: 'it', name: 'Italiano'},
        {id: 'pt', name: 'Português'},
        {id: 'ru', name: 'Русский'},
        {id: 'zh', name: '中文'},
        {id: 'ja', name: '日本語'},
        {id: 'ar', name: 'العربية'},
        {id: 'ko', name: '한국어'},
        {id: 'th', name: 'ไทย'},
        {id: 'vi', name: 'Tiếng Việt'},
        {id: 'el', name: 'Ελληνικά'},
        {id: 'pl', name: 'Polski'},
        {id: 'ro', name: 'Română'},
        {id: 'tr', name: 'Türkçe'},
        {id: 'no', name: 'Norsk'},
        {id: 'fi', name: 'Suomi'},
        {id: 'sv', name: 'Svenska'},
        {id: 'da', name: 'Dansk'},
        {id: 'hi', name: 'हिन्दी'},
        {id: 'ur', name: 'اردو'},
        {id: 'uk', name: 'Українська'},
        {id: 'be', name: 'Беларуская'},
        {id: 'et', name: 'Eesti'},
        {id: 'lv', name: 'Latviešu'},
        {id: 'lt', name: 'Lietuvių'},
        {id: 'fa', name: 'فارسی'},
        {id: 'id', name: 'Indonesia'},
        {id: 'ms', name: 'Melayu (Malaysia)'},
      ],
      myLang: 'en'
    };
  },
  computed: {
    ...mapGetters([
      'getResources'
    ]),
    storeName() {
      return (this.getResources && this.getResources.store) ? this.getResources.store : 'ERP Store';
    },
    url() {
      return (this.getResources && this.getResources.url) ? this.getResources.url : '#';
    },
    footerLinks() {
      const links = (this.getResources && Array.isArray(this.getResources.footerLinks))
        ? this.getResources.footerLinks
        : [];
      return links.filter(link => {
        const name = (link && link.name) ? String(link.name).trim() : '';
        const url = (link && link.url) ? String(link.url).trim() : '';
        return name && /^https:\/\//i.test(url);
      });
    },
    orderedFooterLinks() {
      const rankLink = (link) => {
        const haystack = `${(link && link.name) || ''} ${(link && link.url) || ''}`.toLowerCase();
        if (haystack.includes('about')) return 1;
        if (haystack.includes('contact')) return 2;
        if (haystack.includes('term') || haystack.includes('service')) return 3;
        if (haystack.includes('privacy')) return 4;
        if (haystack.includes('refund')) return 5;
        return 100;
      };

      return this.footerLinks
        .map((link, index) => ({ link, index, rank: rankLink(link) }))
        .sort((a, b) => (a.rank - b.rank) || (a.index - b.index))
        .map(item => item.link);
    },
    footerBranding() {
      const raw = (this.getResources && this.getResources.footerBranding)
        ? this.getResources.footerBranding
        : {};
      const productUrl = (raw && raw.productUrl) ? String(raw.productUrl).trim() : '';
      const authorUrl = (raw && raw.authorUrl) ? String(raw.authorUrl).trim() : '';
      return {
        label: (raw && raw.label) ? String(raw.label).trim() : this.$t('Powered by'),
        productName: (raw && raw.productName) ? String(raw.productName).trim() : this.$t('ERP Store'),
        productUrl: /^https:\/\//i.test(productUrl) ? productUrl : '',
        authorName: (raw && raw.authorName) ? String(raw.authorName).trim() : this.$t('MrZaKaRiA'),
        authorUrl: /^https:\/\//i.test(authorUrl) ? authorUrl : ''
      };
    },
    title() {
      return `${this.$route.name} Page`;
    }
  },
  methods: {
    setPageClass() {
      this.pageClass = `${this.$route.name}-page`.toLowerCase();
    },
    changeLang(){
      this.$i18n.locale = this.myLang;
      localStorage.setItem('lang', this.myLang);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      this.showMenu = false;
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  mounted() {
    this.myLang = (localStorage.getItem('lang'))? localStorage.getItem('lang'):'en';
    this.changeLang();
    this.setPageClass();
  },
  watch: {
    $route() {
      this.setPageClass();
    }
  }
};
</script>
<style lang="scss">
.navbar.auth-navbar {
  top: 0;
}

$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}

/* Auth Page Language Grid */
.language-select-grid .el-scrollbar__view.el-select-dropdown__list {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  min-width: 450px !important;
  padding: 10px;
}

.language-select-grid .el-select-dropdown__item {
  text-align: center;
}

@media (max-width: 767.98px) {
  .wrapper-full-page .full-page {
    min-height: 100svh;
    display: flex;
    flex-direction: column;
  }

  .wrapper-full-page .full-page > .content {
    flex: 1 0 auto;
    padding-top: calc(12px + env(safe-area-inset-top)) !important;
    padding-bottom: 12px !important;
  }

  .wrapper-full-page .full-page > .footer {
    position: relative;
    bottom: auto;
    margin-top: 6px;
    padding-left: 12px !important;
    padding-right: 12px !important;
    padding-bottom: 20px !important;
    padding-bottom: calc(20px + env(safe-area-inset-bottom)) !important;
  }

  .wrapper-full-page .full-page > .footer .container-fluid {
    padding-left: 0;
    padding-right: 0;
  }

  .wrapper-full-page .full-page .footer .auth-footer-nav {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px 4px;
    width: 100%;
    margin: 0 0 10px;
    padding: 0;
    list-style: none;
  }

  .wrapper-full-page .full-page .footer .auth-footer-nav .nav-item {
    width: auto;
    margin: 0;
    min-width: 0;
  }

  .wrapper-full-page .full-page .footer .auth-footer-nav .nav-link {
    display: block;
    padding: 4px 6px;
    text-align: center;
    white-space: normal;
    line-height: 1.2;
    font-size: 0.82rem;
  }

  .wrapper-full-page .full-page .footer .copyright {
    text-align: center;
    margin-top: 10px;
  }

  .wrapper-full-page .full-page .footer .copyright .form-group,
  .wrapper-full-page .full-page .footer .copyright .el-select,
  .wrapper-full-page .full-page .footer .copyright .el-input {
    width: 100%;
  }

  .wrapper-full-page .full-page .card-login,
  .wrapper-full-page .full-page .card-register {
    margin-bottom: 0;
  }

  .wrapper-full-page .full-page .card-login .card-header {
    padding: 0 0 56px !important;
  }

  .wrapper-full-page .full-page .card-register .card-header {
    padding: 0 0 40px !important;
  }

  .wrapper-full-page .full-page .card-login .card-header .card-title,
  .wrapper-full-page .full-page .card-register .card-header .card-title {
    font-size: clamp(3rem, 18vw, 4.2rem) !important;
    line-height: 0.9;
    margin-left: 8px !important;
  }

  .wrapper-full-page .full-page .card.card-register .card-img {
    width: 100%;
    top: -8%;
  }

  .wrapper-full-page .full-page.register-page .content > .container > .row > .col-md-5,
  .wrapper-full-page .full-page.registered-page .content > .container > .row > .col-md-5,
  .wrapper-full-page .full-page.reset-page .content > .container > .row > .col-md-5,
  .wrapper-full-page .full-page.confirmation-page .content > .container > .row > .col-md-5 {
    display: none;
  }

  .wrapper-full-page .full-page.register-page .content > .container > .row > .col-md-7,
  .wrapper-full-page .full-page.registered-page .content > .container > .row > .col-md-7,
  .wrapper-full-page .full-page.reset-page .content > .container > .row > .col-md-7,
  .wrapper-full-page .full-page.confirmation-page .content > .container > .row > .col-md-7 {
    max-width: 100%;
    flex: 0 0 100%;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .language-select-grid .el-scrollbar__view.el-select-dropdown__list {
    grid-template-columns: repeat(2, 1fr) !important;
    min-width: min(440px, calc(100vw - 24px)) !important;
  }
}
</style>
